import { useLang } from "../i18n/LanguageContext";
import { waLink } from "../config";
import { Reveal, Page } from "../components/Reveal";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { WhatsAppIcon } from "../components/icons";

const Avaliacao = () => {
  const { t } = useLang();

  return (
    <Page>
      <SEO title={t.meta.avaliacao.title} desc={t.meta.avaliacao.desc} />
      <PageHero eyebrow={t.avaliacaoPage.eyebrow} title={t.avaliacaoPage.title} desc={t.avaliacaoPage.p} testid="avaliacao-hero" />

      <section className="bg-cream pb-24 sm:pb-32" data-testid="avaliacao-content">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <Reveal className="mb-12">
            <h2 className="font-serif text-2xl font-semibold text-ink sm:text-3xl">{t.avaliacaoPage.itemsTitle}</h2>
            <div className="mt-4 h-px w-16 bg-gold" />
          </Reveal>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {t.avaliacaoPage.items.map((item, i) => (
              <Reveal key={i} delay={(i % 3) * 0.1}>
                <div className="card-lift h-full rounded-3xl bg-white p-7 ring-1 ring-blush">
                  <span className="font-serif text-4xl font-semibold text-blush">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="mt-4 font-serif text-xl font-semibold text-ink">{item.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/55">{item.d}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-16">
            <div className="relative overflow-hidden rounded-[2.5rem] bg-rosedeep px-8 py-14 text-center sm:px-14">
              <div aria-hidden="true" className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
              <h2 className="relative font-serif text-3xl font-semibold text-white sm:text-4xl">
                {t.home.final.title}
              </h2>
              <a
                href={waLink(t.waEval)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="avaliacao-whatsapp-cta"
                className="relative mt-9 inline-flex items-center gap-3 rounded-full bg-rosedeep px-8 py-4 text-[13px] font-bold uppercase tracking-[0.16em] text-white shadow-[0_18px_40px_-14px_rgba(212,122,142,0.85)] transition-all duration-300 hover:bg-ink"
              >
                <WhatsAppIcon className="w-5 h-5" />
                {t.avaliacaoPage.cta}
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </Page>
  );
};

export default Avaliacao;
